import React from "react";
import { WindowSizeInitializer } from "../common/layout/WindowSizeInitializer";
import { RequestSearchInitializer } from "../search/components/RequestSearchInitializer";
import { ValidationInitializer } from "../search/components/ValidationInitializer";
import { UrlValidator } from "../search/validator/UrlValidator";
import { AdsViewInitializer } from "./AdsViewInitializer";
import { criteriaGroupsType } from "../common/types/search/search";

interface InitializersProps {
	criteria: criteriaGroupsType;
	namespace: string;
	searchesEnabled?: boolean;
	showResultsOnInitialPageLoad?: boolean;
}

export const Initializers = ({
	namespace,
	criteria,
	searchesEnabled,
	showResultsOnInitialPageLoad,
}: InitializersProps) => {
	return (
		<>
			<RequestSearchInitializer
				namespace={namespace}
				showResultsOnInitialPageLoad={showResultsOnInitialPageLoad}
				searchesEnabled={searchesEnabled}
			/>
			<ValidationInitializer criteria={criteria} />
			<WindowSizeInitializer />
			<AdsViewInitializer />
			<UrlValidator />
		</>
	);
};
